import { toast } from 'react-toastify';

import apiClient, {downloadFile} from '../../../../../../services/apiClient';


// Сервис для работы со штатным расписанием
export const staffScheduleAPI = {
  // Получить активные должности для садика
  getActivePositions: async (kindergartenId) => {

    try {
        
        const url = `staff-schedule/${kindergartenId}/active`;

        const data = await apiClient.get(url);

        if (!data.data?.success) {
            throw new Error(data.message || 'Помилка при отриманні даних');
        }

      
      return data.data.data;
    } catch (error) {
      console.error('Помилка отримання активних посад:', error);
      //toast.error('Не вдалося завантажити активні посади');
      throw error;
    }
  },

  // Получить архивные должности для садика
  getArchivedPositions: async (kindergartenId) => {
    try {

        const url = `staff-schedule/${kindergartenId}/archived`

        const data = await apiClient.get(url);

        if (!data.data?.success) {
            throw new Error(data.message || 'Помилка при отриманні даних');
        }


      return data.data.data;
    } catch (error) {
      console.error('Помилка отримання архівних посад:', error);
      //toast.error('Не вдалося завантажити архівні посади');
      throw error;
    }
  },

  // Создать новую должность для садика
  createPosition: async (kindergartenId, positionData) => {
    try {

      const url = `staff-schedule/${kindergartenId}`;

       const data = await apiClient.post(url, positionData);
      
      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при створенні посади');
      }
      
      //toast.success('Посаду успішно додано!');
      return data.data.data;
    } catch (error) {
      console.error('Помилка створення посади:', error);
      //toast.error(error.message || 'Не вдалося створити посаду');
      throw error;
    }
  },

  // Обновить должность
  updatePosition: async (kindergartenId, id, positionData) => {
    try {


        const url = `staff-schedule/${kindergartenId}/${id}`;

        const data = await apiClient.put(url, positionData);
      
        if (!data.data?.success) {
            throw new Error(data.message || 'Помилка при оновленні посади');
        }
        
        //toast.success('Посаду успішно оновлено!');
        return data.data.data;
    } catch (error) {
      console.error('Помилка оновлення посади:', error);
      //toast.error(error.message || 'Не вдалося оновити посаду');
      throw error;
    }
  },

  // Архивировать должность
  archivePosition: async (kindergartenId, id) => {
    try {

     const url = `staff-schedule/${kindergartenId}/${id}/archive`;


     const data = await apiClient.patch(url, {});
      
      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при архівації посади');
      }
      
      //toast.success('Посаду успішно переміщено до архіву!');
      return data.data.data;
    } catch (error) {
      console.error('Помилка архівації посади:', error);
      //toast.error('Не вдалося архівувати посаду');
      throw error;
    }
  },

  // Восстановить должность
  restorePosition: async (kindergartenId, id) => {
    try {

            const url = `staff-schedule/${kindergartenId}/${id}/restore`;


     const data = await apiClient.patch(url, {});

      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при відновленні посади');
      }
      
      //toast.success('Посаду успішно відновлено з архіву!');
      return data.data.data;
    } catch (error) {
      console.error('Помилка відновлення посади:', error);
      //toast.error('Не вдалося відновити посаду');
      throw error;
    }
  },

  // Проверить максимальное количество единиц
  checkMaxUnits: async (kindergartenId, positionData) => {
    try {

       const url = `staff-schedule/${kindergartenId}/check-max-units`;

       const data = await apiClient.post(url, positionData);
      
      
      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при перевірці максимальних одиниць');
      }
      
      return data.data.data;
    } catch (error) {
      console.error('Помилка перевірки максимальних одиниць:', error);
      throw error;
    }
  },
  checkMaxRules: async (
   { groupsCount,
    workMode,
    specialization,
    positionId}
  )=>{
     try {

       const url = `staff-calculation-rules/calculate`

       const data = await apiClient.post(url, { positionId, groupsCount, workMode, specialization });
      
      
      if (!data.data?.calculatedUnits) {
        throw new Error(data.message || 'Помилка при перевірці максимальних одиниць');
      }
      
      return data.data.calculatedUnits;
    } catch (error) {
      console.error('Помилка перевірки максимальних одиниць:', error);
      throw error;
    }
  },

  // Получить статистику по садику
  getKindergartenStatistics: async (kindergartenId) => {
    try {

        const url = `staff-schedule/${kindergartenId}/statistics`;

        const data = await apiClient.get(url);
        
        if (!data.data?.success) {
            throw new Error(data.message || 'Помилка при отриманні статистики');
        }
        
        return data.data.data;
        } catch (error) {
        console.error('Помилка отримання статистики:', error);
        throw error;
        }
  }
};


// Сервис для работы со справочником должностей
export const positionsCatalogAPI = {
  // Получить все должности из справочника
  getPositions: async () => {
    try {

        const url = `references/positions`;

        const data = await apiClient.get(url);

      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при отриманні довідника посад');
      }
      
      return data.data.data;
    } catch (error) {
      console.error('Помилка отримання довідника посад:', error);
      //toast.error('Не вдалося завантажити довідник посад');
      throw error;
    }
  },

  // Поиск должностей по названию
  searchPositions: async (searchTerm) => {
    try {

      const url = `references/positions?search=${encodeURIComponent(searchTerm)}`;

      const data = await apiClient.get(url);

      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при пошуку посад');
      }
      
      return data.data.data;
    } catch (error) {
      console.error('Помилка пошуку посад:', error);
      throw error;
    }
  }
};

// Сервис для проверки правил расчета
export const calculationRulesAPI = {
  // Получить доступные режимы работы
  getWorkModes: () => [
    '4 години',
    '9 годин (5-ти денний робочий день)',
    '9 годин (6-ти денний робочий день)',
    '10,5 годин (5-ти денний робочий день)',
    '10,5 годин (6-ти денний робочий день)',
    '12 годин (5-ти денний робочий день)',
    '12 годин (6-ти денний робочий день)',
    '24 години (5-ти денний робочий день)',
    '24 години (6-ти денний робочий день)'
  ],

  // Рассчитать штатные единицы
  calculateUnits: async (calculationData) => {
    try {

       const url = `staff-calculation-rules/calculate`;

       const data = await apiClient.post(url, calculationData);
      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при розрахунку штатних одиниць');
      }
      
      return data.data.data;
    } catch (error) {
      console.error('Помилка розрахунку штатних одиниць:', error);
      throw error;
    }
  }
  
}


export const vacancyReportAPI = {
  // Получить отчет по вакансиям

  
  getVacancyReport: async (kindergartenId) => {

    const POS_FIELDS = [
    "totalUnits",
    "occupiedUnits",
    "vacantUnits"
    ];


   const cor2Float = (a)=>parseFloat(a.toFixed(2));


    const parsePosFloat = (data)=>{
      if(data){

            data = data.map(p=>{
                POS_FIELDS.forEach(pf=>{
                  if(p[pf] && p[pf] > 0) p[pf] = cor2Float(p[pf]);
                });
                return p;
              });
              
          }

        return data;
    }

    try {
      const url = `reports/vacancy?kindergarten_id=${kindergartenId}`;
      const data = await apiClient.get(url);
      
      if (!data.data?.success) {
        throw new Error(data.message || 'Помилка при отриманні звіту по вакансіям');
      }
      
      return parsePosFloat(data.data.data);
    } catch (error) {
      console.error('Помилка отримання звіту по вакансіям:', error);
      //toast.error('Не вдалося завантажити звіт по вакансіям');
      throw error;
    }
  },

  // Экспорт отчета по вакансиям
  exportVacancyReport: async (kindergartenId, format = 'csv') => {
    try {
      const url = `reports/vacancy/export?kindergarten_id=${kindergartenId}&format=${format}`;
      const response = await downloadFile(url, `vacancy_report_${kindergartenId}.${format}`);
      return response;
    } catch (error) {
      console.error('Помилка експорту звіту по вакансіям:', error);
      //toast.error('Не вдалося експортувати звіт');
      throw error;
    }
  }
};